import { FormTable, type FormTableProps } from "@porchpass/ui";

export type DlaFormTableShellProps = FormTableProps & {
  /** Optional width override while keeping the page container unchanged. */
  tableWidthClassName?: string;
};

/** Standard FormTable shell for DLA list/dashboard sections. */
export function DlaFormTableShell({
  className,
  tableWidthClassName = "w-full",
  ...props
}: DlaFormTableShellProps) {
  return (
    <FormTable
      className={[tableWidthClassName, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}
